import styled, { css } from 'styled-components';
import { Button } from '../button/index.js';
import { suppressProps } from '../../utils/index.js';
import { Text } from '../text/index.js';
export const DEFAULT_CHIP_VARIANT = 'standard';
const getChipDisabledStyles = ({ isDisabled, theme }) => {
    if (!isDisabled) {
        return css ``;
    }
    return css `
    cursor: not-allowed;
    opacity: ${theme.styles.chip.states.disabled.opacity};
  `;
};
export const ChipElement = styled.div.withConfig(suppressProps('isDisabled', 'isFocussedExternally', 'isFocusVisible', 'chipLoading'))(({ chipLoading }) => css `
    position: relative;
    cursor: ${chipLoading ? 'default' : 'pointer'};
    align-self: start;
    display: inline-flex;
  `, getChipDisabledStyles);
const getChipButtonStatesStyles = ({ isDisabled, isPressed, loading, isFocusVisible, isFocussedExternally, theme, }) => {
    if (isDisabled) {
        return css ``;
    }
    const { focus, hover, active, pressed } = theme.styles.chip.states;
    const pressedStyles = css `
    border-color: ${pressed.borderColor};
    background-color: ${pressed.backgroundColor};
    color: ${pressed.color};
  `;
    const focusStyles = isFocussedExternally
        ? css `
        outline: ${focus.outline?.rule};
        outline-offset: ${focus.outline?.offset};
      `
        : css `
        &:focus {
          outline: ${isFocusVisible ? focus.outline?.rule : focus.outlineNone};
          outline-offset: ${focus.outline?.offset};
        }
      `;
    if (loading) {
        return focusStyles;
    }
    if (isPressed) {
        return css `
      ${focusStyles}
      ${pressedStyles}
    `;
    }
    return css `
    &:hover {
      text-decoration: none;
      border-color: ${hover.borderColor};
      background-color: ${hover.backgroundColor};
      color: ${hover.color};
    }

    &:active {
      border-color: ${active.borderColor};
      background-color: ${active.backgroundColor};
      color: ${active.color};
    }

    ${focusStyles}
    ${isPressed && pressedStyles}
  `;
};
export const ChipButtonElement = styled.button.withConfig(suppressProps('closeButtonIsVisible', 'isDisabled', 'isFocussedExternally', 'isFocusVisible', 'isPressed', 'variant', 'loading'))(({ closeButtonIsVisible, variant = DEFAULT_CHIP_VARIANT, theme, }) => {
    const { borderColor, backgroundColor, color } = theme.styles.chip.states.default;
    const { borderStyle, borderWidth } = theme.styles.chip.common;
    const { borderRadius, padding, paddingRight, minWidth, maxWidth, height, } = theme.styles.chip.variants[variant];
    return css `
        border-radius: ${borderRadius};
        border-width: ${borderWidth};
        border-style: ${borderStyle};
        border-color: ${borderColor};
        background-color: ${backgroundColor};
        color: ${color};
        padding-left: ${padding};
        padding-right: ${closeButtonIsVisible ? paddingRight : padding};
        min-width: ${minWidth};
        max-width: ${maxWidth};
        height: ${height};
        cursor: inherit;
        display: flex;
        align-items: center;
        outline: ${theme.styles.chip.states.focus.outlineNone};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: none;
      `;
}, getChipButtonStatesStyles);
export const ChipCloseButtonElement = styled(Button).withConfig(suppressProps('chipVariant', 'isPressed'))(({ chipVariant = DEFAULT_CHIP_VARIANT, isPressed, theme, }) => {
    const { outlineOffset } = theme.styles.chip.common.closeButton;
    const { width, height } = theme.styles.chip.variants[chipVariant].closeButton;
    return css `
      display: flex;
      align-items: center;
      height: ${height};
      width: ${width};
      border-radius: 50%;
      position: absolute;
      top: 0;
      right: 0;
      color: ${isPressed ? theme.styles.chip.states.pressed.color : 'inherit'};

      &:focus {
        outline-offset: ${outlineOffset};
      }
    `;
});
export const ChipTextElement = styled(Text).withConfig(suppressProps('chipLoading'))(({ chipLoading }) => {
    if (chipLoading === 'spinner') {
        return css `
      color: transparent;
    `;
    }
    return css ``;
});
//# sourceMappingURL=chip.styles.js.map